import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing.space12,
    borderRadius: theme.radius.small,
    background: theme.colors.Background3,
    alignItems: "center",
    height: 75,
  },
  statContent: {
    display: "flex",
    flexDirection: "column",
  },
  statName: {
    paddingBottom: theme.spacing.space4,
  },
  statDescription: {
    paddingTop: theme.spacing.space8,
  },
  statIcon: {
    width: 48,
    height: 48,
  },
}));
